export const openUrlPopup = (
  url: string,
  width = 1000,
  height = 680,
  x = 180,
  y = 110,
) =>
  window.open(
    url,
    "_blank",
    `width=${width},height=${height},left=${x},top=${y}`,
  )
